import priceCalculator from './priceCalculator'

const variantProductUtil = {}

// ========== FUNCIONES UTILITARIAS ==========

/**
 * Verifica si un item tiene stock disponible
 */
const itemWithStock = item => {
  const { sellWithoutStock, quantity = 0 } = item.inventorySettings || {}
  if (!sellWithoutStock && quantity <= 0) return false
  return true
}

/**
 * Hereda propiedades del producto padre a la variante si no las tiene
 */
const inheritParentProperties = (variant, parentProduct) => {
  const propertiesToInherit = [
    { key: 'discounts', clone: 'deep' },
    { key: 'taxes', clone: 'deep' },
    { key: 'name', clone: 'shallow' },
    { key: 'category', clone: 'shallow' }
  ]

  propertiesToInherit.forEach(({ key, clone }) => {
    if (!variant[key] && parentProduct[key]) {
      variant[key] = clone === 'deep'
        ? (Array.isArray(parentProduct[key]) ? [...parentProduct[key]] : { ...parentProduct[key] })
        : parentProduct[key]
    }
  })

  // Siempre asignar idVariantParent
  variant.idVariantParent = parentProduct.id
}

/**
 * Calcula precios finales para una variante usando priceCalculator centralizado
 */
const calculateVariantFinalPrices = (variant) => {
  // Usar la función centralizada de priceCalculator para procesamiento consistente
  const processedVariant = priceCalculator.processProductWithFinalPrices(variant)
  variant.finalPriceBeforeDiscounts = processedVariant.finalPriceBeforeDiscounts
  variant.finalPrice = processedVariant.finalPrice
}

/**
 * Valida que las variantes seleccionadas sean válidas
 */
const validateVariantSelections = (product, variantsSelected) => {
  if (!variantsSelected.length) {
    return { isValid: false, errorMsg: 'Selecciona las variantes del producto' }
  }

  for (const variant of product.variantAttributes) {
    const selectedVariant = variantsSelected.find(
      selectedVariant => selectedVariant?.idVariant === variant.id
    )
    if (!selectedVariant) {
      return { isValid: false, errorMsg: `Selecciona la variante ${variant.name}` }
    }
  }

  return { isValid: true }
}

// ========== FUNCIÓN PRINCIPAL REFACTORIZADA ==========

variantProductUtil.searchVariant = (product, variantsSelected) => {
  const response = {
    status: 'SUCCESS',
    variant: null,
    errorMsg: null
  }

  // 1. Validar selecciones de variantes
  const validationResult = validateVariantSelections(product, variantsSelected)
  if (!validationResult.isValid) {
    response.status = 'ERROR'
    response.errorMsg = validationResult.errorMsg
    return response
  }

  // 2. Buscar la variante que coincida con las selecciones
  const foundVariant = findMatchingVariant(product.itemVariants, variantsSelected, product.variantAttributes.length)

  if (!foundVariant) {
    response.status = 'ERROR'
    response.errorMsg = 'No se encontró una variante que coincida con la selección'
    return response
  }

  // 3. Verificar stock
  if (!itemWithStock(foundVariant)) {
    response.status = 'ERROR'
    response.errorMsg = 'Producto agotado'
    return response
  }

  // 4. Procesar la variante encontrada
  response.variant = foundVariant

  // 5. Aplicar herencia de propiedades del padre
  inheritParentProperties(response.variant, product)

  // 6. Calcular precios finales usando priceCalculator centralizado
  calculateVariantFinalPrices(response.variant)

  return response
}

/**
 * Busca una variante que coincida exactamente con las selecciones
 */
const findMatchingVariant = (itemVariants, variantsSelected, expectedAttributesCount) => {
  for (const item of itemVariants) {
    let matchingAttributes = 0

    for (const selectedVariant of variantsSelected) {
      const variantAttribute = item.variantAttributes.find(({ id }) => id === selectedVariant.idVariant)
      if (variantAttribute?.options[0].id === selectedVariant.idOption) {
        matchingAttributes++
      }
    }

    if (matchingAttributes === expectedAttributesCount) {
      return item
    }
  }

  return null
}

export default variantProductUtil
